import { createMemo } from 'react-use'
import { useModelStore, useResultsStore } from '@editorStores'

const positionGuidToWallGuid = (
  rips: Rip[],
  lintels: Lintel[],
  standardRipChecks: StandardRipCheck[] | null,
): Record<string, string> => {
  const collector: Record<string, string> = {}
  for (const item of rips) collector[item.position_guid] = item.wall_guid
  for (const item of lintels) collector[item.position_guid] = item.wall_guid
  // Standard rip checks override the rip/lintel mapping where they collide.
  if (standardRipChecks) {
    for (const check of standardRipChecks) {
      collector[check.standard_rip_member.guid] = check.wall_guid
    }
  }
  return collector
}

const useMapPositionGuidToWallGuid = createMemo(positionGuidToWallGuid)

const usePositionGuidToWallGuid = (): Record<string, string> => {
  const rips = useModelStore(state => state.model.rips)
  const lintels = useModelStore(state => state.model.lintels)
  const standardRipChecks = useResultsStore(state => state.standardRipChecks)

  return useMapPositionGuidToWallGuid(rips, lintels, standardRipChecks)
}

export default usePositionGuidToWallGuid
